import styled from 'styled-components';

export const CarouselWrapper = styled.div`
  overflow: hidden;

  .ant-carousel {
    .slick-slide {
      height: auto !important;
    }
    .slick-list {
      height: auto !important;
      overflow: hidden !important;
    }
    .slick-track {
      height: auto !important;
    }
  }
`;
